/* eslint-disable quotes */
import React, { useRef } from "react";
import PropTypes from "prop-types";
// Material imports
import HelpIcon from "@mui/icons-material/HelpOutline";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
// Limitless imports
import HelpPanel from "../../help-panel/HelpPanel";
import IconMenu from "../../icon-menu/IconMenu";
import HelpHighlightPopper from "../../poppers/help-highlight-popper/HelpHighlightPopper";
import { useTranslation } from "@limitless/common/hooks";
import { useGuideDrawer } from "../../../hooks/guide-drawer/GuideDrawerHook";
import { useExpertProfileContext } from "@limitless/expert";
import { recordPageView } from "@limitless/analytics";
import { useLocation } from "react-router-dom";
import { POLICY_PAYMENTS_ACCESS } from "@limitless/portal/utils";
const useStyles = makeStyles(theme => ({
  portalMenu: {
    justifyContent: "space-between",
    paddingLeft: 16,
    paddingRight: 60,
    marginBottom: 4,
    marginTop: 4,
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: "transparent"
    }
  },
  helpMenuHeader: {
    justifyContent: "space-between",
    padding: 0,
    paddingTop: 8,
    marginLeft: 16
  },
  legalMenuHeader: {
    justifyContent: "space-between",
    padding: 0,
    paddingTop: 16,
    marginLeft: 16
  }
}));
const AppHelpHeaderItem = ({
  handleNavigate
}) => {
  const {
    isGuideOpen,
    toggleGuide
  } = useGuideDrawer();
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const buttonRef = useRef();
  const {
    profile: {
      helpGuideAvailable
    },
    canUserAccess
  } = useExpertProfileContext();
  const hasPaymentAccess = canUserAccess(POLICY_PAYMENTS_ACCESS);
  const loaction = useLocation();
  const handleOpenLimitlessGuideClick = () => {
    toggleGuide();
    recordPageView("Limitless Guide", loaction.pathname);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: buttonRef
  }, /*#__PURE__*/React.createElement(IconMenu, {
    id: "helpHeaderMenuButton",
    tooltip: "Help menu",
    ariaLabel: "Help",
    icon: /*#__PURE__*/React.createElement(HelpIcon, {
      style: {
        pointerEvents: "none"
      },
      id: "helpIcon"
    }),
    iconColor: "primaryContrast",
    placement: "bottom-end",
    color: "primaryContrast"
  }, /*#__PURE__*/React.createElement("li", {
    className: classes.helpMenuHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, t("HELP"))), helpGuideAvailable && /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "guideNavItem",
    onClick: handleOpenLimitlessGuideClick
  }, t("Open Limitless Guide")), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "tutorialsNavItem",
    onClick: () => handleNavigate("/tutorials")
  }, t("Tutorial Videos")), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "faqsNavItem",
    onClick: () => handleNavigate("/knowledge")
  }, t("FAQs")), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "contactNavItem",
    onClick: () => window.open(t("http://belimitless.io/appcontacts/"))
  }, t("Contact Support")), hasPaymentAccess && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: 8
    }
  }), /*#__PURE__*/React.createElement("li", {
    className: classes.legalMenuHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, t("LEGAL"))), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "termsNavItem",
    onClick: () => {
      handleNavigate("/legal");
      handleNavigate("/legal/0");
    }
  }, t("Terms & Conditions")), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "privacyNavItem",
    onClick: () => {
      handleNavigate("/legal");
      handleNavigate("/legal/1");
    }
  }, t("Privacy Policy")), /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    id: "conductNavItem",
    onClick: () => {
      handleNavigate("/legal");
      handleNavigate("/legal/2");
    }
  }, t("Code of Conduct")), /*#__PURE__*/React.createElement(MenuItem, {
    id: "idtaNavItem",
    onClick: () => {
      handleNavigate("/legal");
      handleNavigate("/legal/3");
    }
  }, t("International Data Transfer Addendum")))), /*#__PURE__*/React.createElement(HelpHighlightPopper, {
    buttonRef: buttonRef.current,
    icon: HelpIcon
  }), /*#__PURE__*/React.createElement(HelpPanel, {
    showHelp: isGuideOpen,
    setShowHelp: toggleGuide
  }));
};
AppHelpHeaderItem.propTypes = {
  handleNavigate: PropTypes.func
};
export default AppHelpHeaderItem;